// console.log('gene-therapy');

var slider = $('.gt-top__image-slider').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: false,
    draggable: false
});

$('.gt-top__description').on('click', function(evt) {
    var parent = $(this).parents('.gt-top__item');
    var accordion = parent.find('.gt-top__accordion');
    var slideID = parent.attr('data-list-item');

    if(!parent.hasClass('gt-top__item--open')) {
        $('.gt-top__item--open').removeClass('gt-top__item--open').find('.gt-top__accordion').slideUp(250);
        parent.addClass('gt-top__item--open');
        accordion.slideDown(250);
        slider.slick('slickGoTo', slideID);
    } else {
        parent.removeClass('gt-top__item--open');
        accordion.slideUp(250);
    }
});
  


// WEBPACK FOOTER //
// ./scripts/gutenberg_components/_gene-therapy.js